module.exports = __webpack_public_path__ + "img/customer-service-icon.405313f0.svg";